import React, { Component } from 'react'
import { connect } from 'react-redux'
import Locations from './Locations'
import LinearProgess from 'material-ui/Progress/LinearProgress'
import { clearSuccessMessage, resetInMemoryLocation, fetchLocations, updateInMemoryLocation } from './locations-reducer'
import { fetchClients } from '../app/users-reducer'

class LocationsContainer extends Component {
  componentDidMount () {
    const {
      fetchLocations,
      fetchClients,
      locations,
      clients
    } = this.props

    if (locations.length === 0) {
      fetchLocations()
    }
    if (clients.length === 0) {
      fetchClients()
    }
  }

  render () {
    const { locations, requestOngoing, updateInMemoryLocation, history, clearSuccessMessage, resetInMemoryLocation, isClientRequestOngoing } = this.props
    let viewToRender

    const handleEditBtn = location => {
      // update the in memory and move to the form url
      updateInMemoryLocation(location)
      clearSuccessMessage()
      // now move to new form route
      history.push('/locations/form')
    }

    const handleNewLocation = () => {
      resetInMemoryLocation()
      clearSuccessMessage()
      history.push('/locations/form')
    }

    if (requestOngoing || isClientRequestOngoing) {
      viewToRender = <LinearProgess />
    } else {
      viewToRender = <Locations locations={locations} handleEditBtn={handleEditBtn} handleNewLocation={handleNewLocation} />
    }

    return <div>
      <h4>Locations</h4>
      {viewToRender}
    </div>
  }
}

const mapStateToProps = ({locations: {locations, requestOngoing}, users: {clients, isClientRequestOngoing}}) => ({
  locations,
  clients,
  requestOngoing,
  isClientRequestOngoing
})

const mapDispatchToProps = {
  fetchLocations,
  fetchClients,
  updateInMemoryLocation,
  resetInMemoryLocation,
  clearSuccessMessage
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsContainer)



// WEBPACK FOOTER //
// ./src/locations/LocationsContainer.js